import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { ConfiguracoesPJFormData } from "@/pages/configuracoes/schemas";

interface CompanyInformationProps {
  form: UseFormReturn<ConfiguracoesPJFormData>;
}

export function CompanyInformation({ form }: CompanyInformationProps) {
  return (
    <div className="flex flex-col gap-[24px]">
      {/* Row 1: Razão Social | CNPJ */}
      <div className="flex gap-[29px]">
        <FormField
          control={form.control}
          name="razaoSocial"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Razão Social
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="cnpj"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                CNPJ
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Row 2: Endereço | Bairro */}
      <div className="flex gap-[29px]">
        <FormField
          control={form.control}
          name="enderecoEmpresarial"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Endereço empresarial com logradouro, número e complemento (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="bairroPJ"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Bairro (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Row 3: Cidade/Estado | CEP */}
      <div className="flex gap-[29px]">
        <FormField
          control={form.control}
          name="cidadeEstadoPJ"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Cidade, Estado (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="cepPJ"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                CEP (PJ)
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      {/* Row 4: CNAEs | Inscrição Municipal */}
      <div className="flex gap-[29px]">
        <FormField
          control={form.control}
          name="cnaes"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                CNAEs
              </label>
              <FormControl>
                <Input placeholder="xx/xx/xxxx" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="inscricaoMunicipal"
          render={({ field }) => (
            <FormItem className="flex-1">
              <label className="font-['Plus_Jakarta_Sans'] font-bold text-[16px] text-white leading-normal">
                Inscrição Municipal
              </label>
              <FormControl>
                <Input placeholder="Digite aqui" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
